import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

import { ProductGridComponent } from '@common/product-grid/product-grid.component';
import { MarketingCategoryComponent } from '@common/marketing-category/desktop/marketing-category.component';
import { MiniHomeModel } from '../mini-home.model';
import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';
import { Constants } from '@helper/constants';
import { MarketingCategoryModel } from '@common/marketing-category/marketing-category.model';
import { PriceMetaComponent } from '@common/price-meta/price-meta.component';
import { TypedTemplateDirective } from '@helper/typed-template.directive';
import { BaseLoadMoreComponent } from '../../base-load-more-component';
import { Links } from '@helper/links';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';

@Component({
  selector: 'app-mini-home',
  templateUrl: './mini-home.component.html',
  styleUrls: ['./mini-home.component.scss'],
  imports: [
    ProductGridComponent,
    MarketingCategoryComponent,
    ImageLoadingComponent,
    NgIf,
    PriceMetaComponent,
    TypedTemplateDirective,
    FocusRemoverDirective,
    RouterLink,
  ],
  providers: [MiniHomeModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniHomeComponent extends BaseLoadMoreComponent implements OnInit {
  readonly columns = 4;
  readonly pageSize = Constants.APP_CONTAINER_WIDTH - 170;
  readonly typeToken = ProductGridComponent.typeToken;
  readonly imageLink = computed(() => {
    const link = this.viewModel.currentCategory()?.link;
    if (!link) {
      return '';
    }
    return Links.extractUrl(link);
  });

  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  @Input() nameEn?: string;

  constructor(
    public viewModel: MiniHomeModel,
    public categoryViewModel: MarketingCategoryModel
  ) {
    super(viewModel.itemCount, Constants.displayCount(viewModel.detectService.isMobileDevice()));
  }

  ngOnInit(): void {
    if (this.nameEn) {
      this.categoryViewModel.currentBigId.set(this.nameEn);
    }
    this.categoryViewModel.currentMediumId.set('');
    this.categoryViewModel.currentSmallId.set('');
    this.viewModel.getMiniHome(this.destroyRef);
  }

  openProduct(link: string | undefined, event: MouseEvent): void {
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey) {
      return;
    }
    Links.handleLink(this.router, link);
  }
}
